import type { AnalyticsApi } from '@liks/lac-svc-api/esm/apis/AnalyticsApi';
import type {
  CrawlJobPeriodCountDTO,
  CrawlJobTenantAnalyticsDTO,
} from '@liks/lac-svc-api/esm/models/index';
import type {
  LacCrawlJobAnalyticsOptions,
  LacCrawlJobTimeSeriesOptions,
} from './lacAnalyticsServiceTypes';

export async function getCrawlJobTimeSeries(
  analyticsApi: AnalyticsApi,
  { tenantName, groupBy, fromDate, toDate }: LacCrawlJobTimeSeriesOptions,
): Promise<CrawlJobPeriodCountDTO[]> {
  const trimmedName = tenantName?.trim() ?? '';

  return analyticsApi.deLiksAnalyticsBoundaryAnalyticsResourceListCrawlJobTimeSeries(
    {
      groupBy,
      fromDate,
      toDate,
      tenantName: trimmedName === '' ? undefined : trimmedName,
    },
  );
}

export async function getCrawlJobAnalytics(
  analyticsApi: AnalyticsApi,
  { tenantName, fromDate, toDate }: LacCrawlJobAnalyticsOptions,
): Promise<CrawlJobTenantAnalyticsDTO | null> {
  const trimmedName = tenantName.trim();
  if (trimmedName === '') {
    return null;
  }

  const page =
    await analyticsApi.deLiksAnalyticsBoundaryAnalyticsResourceListCrawlJobAnalytics(
      {
        tenantName: trimmedName,
        fromDate,
        toDate,
      },
    );

  return page[0] ?? null;
}
